(function ($) {
    $(document).ready(function () {

        var div = $('.vimeo-video');

        $.each(div, function (idx, val) {
            
            var url = $(this).data('videourl');
            var parsed = parseVideo(url);
			var videoTitle = $(this).data('videotitle');
			
			if (videoTitle != '' && videoTitle != null && videoTitle != undefined) {
				videoTitle = 'Vimeo video: ' + validator.escape(videoTitle);
			} else {
				videoTitle = 'Vimeo video player';
			}
            
			var frame =  '<iframe src="https://player.vimeo.com/video/' + parsed.id + '?portrait=0&title=1&byline=0" title="' + videoTitle + '" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
			
            $(this).append(frame);
            
        });

    });
		
	function parseVideo(url) {
	    // - Supported YouTube URL formats:
	    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
	    //   - http://youtu.be/My2FRPA3Gf8
	    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
	    // - Supported Vimeo URL formats:
	    //   - http://vimeo.com/25451551
	    //   - http://player.vimeo.com/video/25451551
	    // - Also supports relative URLs:
	    //   - //player.vimeo.com/video/25451551
	
	    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
	
	    if (RegExp.$3.indexOf('youtu') > -1) {
	        var type = 'youtube';
	    } else if (RegExp.$3.indexOf('vimeo') > -1) {
	        var type = 'vimeo';
	    }
	
	    return {
	        type: type,
	        id: RegExp.$6
	    };
	}

})(jQuery);